import React from 'react';
import { Users, BookCopy, Gift, Star } from 'lucide-react';
export function SocialProofBar() {
  return <div className="bg-carbon text-cream py-8 px-4 border-y-4 border-brand-green" data-id="element-246">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-247">
        <div className="flex flex-col items-center justify-center" data-id="element-248">
          <Users className="w-8 h-8 mb-2 text-brand-green" data-id="element-249" />
          <p className="font-bold text-xl md:text-2xl" data-id="element-250">+300</p>
          <p className="text-sm text-cream-dark" data-id="element-251">
            familias y emprendedores confían
          </p>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-252">
          <BookCopy className="w-8 h-8 mb-2 text-brand-green" data-id="element-253" />
          <p className="font-bold text-xl md:text-2xl" data-id="element-254">6 Tomos</p>
          <p className="text-sm text-cream-dark" data-id="element-255">listos</p>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-256">
          <Gift className="w-8 h-8 mb-2 text-brand-green" data-id="element-257" />
          <p className="font-bold text-xl md:text-2xl" data-id="element-258">3 Bonos</p>
          <p className="text-sm text-cream-dark" data-id="element-259">incluidos</p>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-260">
          <div className="flex gap-1 mb-2 text-yellow-400" data-id="element-261">
            <Star className="w-6 h-6 fill-current" data-id="element-262" />
            <Star className="w-6 h-6 fill-current" data-id="element-263" />
            <Star className="w-6 h-6 fill-current" data-id="element-264" />
            <Star className="w-6 h-6 fill-current" data-id="element-265" />
            <Star className="w-6 h-6 fill-current" data-id="element-266" />
          </div>
          <p className="font-bold text-xl md:text-2xl" data-id="element-267">4.9/5</p>
          <p className="text-sm text-cream-dark" data-id="element-268">calificación ⭐</p>
        </div>
      </div>
    </div>;
}